import React from 'react'
import * as XLSX from 'xlsx';
import { httpss } from '../../utils/host';

export default function ExportConnected() {
    const handleExport = async () => {
        try {
            const res = await fetch(`${httpss}/apis_v1/user/connected`);
            const json = await res.json();
        
            if (!json || !Array.isArray(json.data)) {
              alert('Không có dữ liệu để xuất.');
              return;
            }
        
            const exportData = json.data.map(item => ({
              ID: item.id,
              Email: item.mail,
              Name: item.name,
              User365Name: item.User365Name,
              FanPageFBName: item.FanPageFBName,
              CreatedAt: new Date(item.createdAt).toLocaleString(),
            }));
        
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Connected");
        
            XLSX.writeFile(workbook, "Connected_export.xlsx");
          } catch (err) {
            console.error("❌ Lỗi khi xuất Excel:", err);
            alert("Có lỗi xảy ra khi xuất file.");
          }
    }

  return (
    <button onClick={handleExport} className='bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg transition'>Xuất Excel</button>
  )
}
